import { openCopilotChatDrawerMutator } from "../mutators/openCopilotChatDrawerMutator";
import { onCopilotChatDrawerLayoutChange } from "../actions/onCopilotChatDrawerLayoutChange";
import { onCopilotChatDrawerOpened } from "../actions/onCopilotChatDrawerOpened";
import { updateCopilotChatDrawerPinnedPaneAction } from "../actions/updateCopilotChatDrawerPinnedPaneAction";
import { isCopilotChatDrawerShown } from "../selectors/isCopilotChatDrawerShown";
import { logCopilotChatSidePaneTelemetryEvent } from "owa-copilot-telemetry/lib/copilotChatSidePaneTelemetryLogger";
import { getCurrentModule } from "owa-app-module-store";
import isPopout from "owa-popout-v2/lib/utils/isPopout";
import { getBizChatWindowKey } from "../utils/getBizChatWindowKey";
import type { MailboxInfo } from "owa-client-types";
import type { CopilotDrawerContent } from "../types/CopilotDrawerContent";
import { getSidePaneOpenToCloseSessionId, getTimeSinceSidepaneOpened, } from "../utils/sidePaneOpenToCloseSessionId";

const openedContentByWindow = new WeakMap<Window, CopilotDrawerContent>();

/** The content the current drawer cycle in `targetWindow` was opened to show. */
export function getCopilotChatDrawerOpenedContent(targetWindow: Window): CopilotDrawerContent {
    return openedContentByWindow.get(targetWindow) ?? "chat";
}

export function openCopilotChatDrawer(targetWindow: Window, mailboxInfo?: MailboxInfo, customData?: {
    [key: string]: string;
}, content: CopilotDrawerContent = "chat"): void {
    if (isCopilotChatDrawerShown(targetWindow)) {
        // If already shown, no need to open again.
        // This happens if a caller tries too optimistically to open the drawer
        // without checking if it's already open.
        return;
    }
    
    openedContentByWindow.set(targetWindow, content);
    if (content === "chat") {
        logCopilotChatSidePaneTelemetryEvent("CopilotSidePane_BizChatOpened", {
            source: getCurrentModule(),
            isDrawerPane: true,
            isPopout: isPopout(targetWindow),
            windowKey: getBizChatWindowKey(targetWindow),
            sidePaneOpenToCloseSessionId: getSidePaneOpenToCloseSessionId(targetWindow),
            timeSinceOpened: getTimeSinceSidepaneOpened(targetWindow),
            ...customData,
        }, mailboxInfo);
    }
    
    openCopilotChatDrawerMutator(targetWindow);
    
    onCopilotChatDrawerOpened(targetWindow); // Action for listeners when drawer is opened
    
    // Save the Copilot Chat Drawer as a pinned pane setting, for sticky open.
    // We do this only if we're in main window
    if (targetWindow === window) {
        onCopilotChatDrawerLayoutChange();
        updateCopilotChatDrawerPinnedPaneAction(true /* isSavingAsCopilotChatDrawer */);
    }
}
